module.exports = __webpack_public_path__ + "static/media/como-comprar.2e89b296.jpg";